<template>
  <div class="lable">
    <slot/>
  </div>
</template>
<script>
  export default {
    name: "CommonLable"
  };
</script>
<style lang="scss" scope>
  .lable {
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0;
    color: #333;
    margin-bottom: 18px;
  }
</style>
